import { useTranslation } from "react-i18next";
import { ArrowUp, ArrowDown, Gift, Send, Sparkles, RefreshCw } from "lucide-react";

const ICON_BY_TYPE = {
  welcome_bonus: Gift,
  purchase: ArrowUp,
  consume_ia: ArrowDown,
  transfer_in: ArrowUp,
  transfer_out: Send,
  aiko_out: Send,
  coupon_bonus: Sparkles,
  monthly_grant: RefreshCw,
  admin_adjust: Sparkles,
};

function relativeTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diffMs = Date.now() - d.getTime();
  const minutes = Math.round(diffMs / 60000);
  if (minutes < 1) return "ahora";
  if (minutes < 60) return `hace ${minutes} min`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `hace ${hours} h`;
  const days = Math.round(hours / 24);
  if (days === 1) return "ayer";
  if (days < 7) return `hace ${days} d`;
  return d.toLocaleDateString();
}

function shortRef(ref) {
  if (!ref) return "";
  if (ref.length <= 14) return ref;
  return `${ref.slice(0, 8)}…`;
}

export default function HistoryList({ transactions = [] }) {
  const { t } = useTranslation();
  if (!transactions.length) {
    return (
      <p
        data-testid="history-empty"
        className="text-[12px] text-[#9CA3AF] text-center py-6"
      >
        {t("billing.history.empty")}
      </p>
    );
  }
  return (
    <ul
      data-testid="history-list"
      className="flex flex-col divide-y divide-white/[0.05]"
    >
      {transactions.slice(0, 10).map((tx, i) => {
        const Icon = ICON_BY_TYPE[tx.type] || Sparkles;
        const isCredit = tx.amount > 0;
        return (
          <li
            key={`${i}-${tx.created_at}`}
            data-testid={`history-row-${i}`}
            className="flex items-center gap-3 py-2.5"
          >
            <div
              className={`
                h-8 w-8 rounded-full shrink-0 flex items-center justify-center
                ${isCredit
                  ? "bg-[rgba(0,229,255,0.12)] border border-[rgba(0,229,255,0.35)] text-[#00E5FF]"
                  : "bg-white/[0.04] border border-white/[0.08] text-[#9CA3AF]"}
              `}
            >
              <Icon className="h-3.5 w-3.5" strokeWidth={1.75} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[12.5px] text-[#E5E7EB] truncate">
                {t(`billing.tx_type.${tx.type}`, {
                  ref: shortRef(tx.ref_id),
                  defaultValue: tx.note || tx.type,
                })}
              </p>
              <p className="text-[10.5px] text-[#9CA3AF]">
                {relativeTime(tx.created_at)}
              </p>
            </div>
            <p
              className={`text-[13px] font-mono shrink-0 ${
                isCredit ? "text-[#00E5FF]" : "text-[#E5E7EB]/70"
              }`}
            >
              {isCredit ? "+" : ""}
              {tx.amount}
            </p>
          </li>
        );
      })}
    </ul>
  );
}
